import { Component  } from 'react';
import { connect } from "react-redux";

import { addSettings } from "../../../actions";
import {
  listAgentForms,
  saveAgentResponse,
  viewAgentFormSingleSubmission,
} from "./../../../config/agent_forms_api_calls";
import { APP_LIVE_URL } from "../../../config/config";
import $ from "jquery";
import DataTableExtended from "../../../components/Tables/DataTableExtended";
import FormRenderer from "../../../components/formRender";
import { TableLoader } from "../../../components/ContentLoaders/newLoaders/TableLoader";
import MsaWarning from "../ExtraComponents/MsaWarning";
import SettingsError from "../ExtraComponents/SettingsError";
import PageTitle from "../ExtraComponents/PageTitle";
import HelperClass from "./../../../config/helperClass";
import dateFormat from "dateformat";
import Tooltip from "@material-ui/core/Tooltip";

const auth = new HelperClass();

class Forms extends Component {
  constructor() {
    super();

    this.state = {
      tableData: [],
      tableDataSingle: [],
      serviceData: [],
      tableLoaderListing: true,
      tableLoader: true,
      errorMessage: "",
      successMessage: "",
      showModal: false,
      modalContent: null,
      formAccNo: "",
      successMessageSaveResponse: "",
      errorMessageSaveResponse: "",
      columnServices: [
        { name: "form_sequence", label: "Form Sequence" },
        {
          name: "form_title",
          label: "Form Title",
          // options: {
          //   customBodyRender: (value, tableMeta) => {
          //     const formAccNo =
          //       this.state.tableData[tableMeta.rowIndex].form_link; // same as Actions
          //     const isLinkForm =
          //       this.state.tableData[tableMeta.rowIndex].link_form === 1;

          //     return isLinkForm ? (
          //       <span
          //         style={{
          //           color: "#666",
          //           cursor: "default",
          //         }}
          //         title="Link Form - No Submissions to View"
          //       >
          //         {value}
          //       </span>
          //     ) : (
          //       <a
          //         style={{
          //           color: "#4b7bec",
          //           cursor: "pointer",
          //           textDecoration: "underline",
          //         }}
          //         onClick={() =>
          //           this.addMenuHistory("/agent_form_submissions/" + formAccNo)
          //         }
          //         title="View Submissions"
          //       >
          //         {value}
          //       </a>
          //     );
          //   },
          // },
        },
        // {
        //   name: "allow_multiple",
        //   label: "Multiple Submission",
        //   options: {
        //     customBodyRender: (value, tableMeta, updateValue) => {
        //       return <div>{this.handleSubmission(value, tableMeta)}</div>;
        //     },
        //   },
        // },
        { name: "is_filled", label: "Filled" },
        {
          name: "filled_date",
          label: "Filled Date",
          options: {
            customBodyRender: (value, tableMeta, updateValue) => {
              return <div>{this.format_date(value)}</div>;
            },
          },
        },
        {
          name: "form_accountno",
          options: {
            display: false,
          },
        },
        {
          name: "submission_status",
          options: {
            display: false,
          },
        },
        {
          name: "Respond_to_form",
          label: "Actions",
          options: {
            customBodyRender: (value, tableMeta) => {
              const row = this.state.tableData[tableMeta.rowIndex] || {};
              const allowMultiple = row.allow_multiple;
              const isFilled = row.is_filled;
              const formLink = row.form_link;
              const isAiAgentLink = row.is_ai_agent_link;
              const linkForm = row.link_form;
              const externalLink = row.external_link;
              const submissionStatus = row.submission_status;

              const isAgentLink =
                isAiAgentLink === "Yes" ||
                linkForm === 1 ||
                linkForm === "1";

              const isMultiple = allowMultiple === 1 || allowMultiple === "1";
              const isSubmitted =
                String(isFilled).toLowerCase() === "yes" ||
                isFilled === 1 ||
                isFilled === "1";
              const isRejected = submissionStatus === 2;
              const isApproved = isSubmitted && submissionStatus === 1;
              const isPending = isSubmitted && !isApproved && !isRejected;

              const formToken = formLink && formLink.includes("/")
                ? formLink.split("/")[1]
                : formLink;

              const iconStyle = { fontSize: "1.4rem" };

              const divider = (
                <span style={{ color: "#dbdfea", userSelect: "none" }}>|</span>
              );

              const fillFormAction = (
                <Tooltip title="Fill Form" placement="top" arrow>
                  <a
                    style={{ cursor: "pointer" }}
                    onClick={() => this.addMenuHistory("/agent_form_submit/" + formLink)}
                  >
                    <em className="icon ni ni-edit text-primary" style={iconStyle}></em>
                  </a>
                </Tooltip>
              );

              const linkOnlyAction = (
                <Tooltip title="Link Only" placement="top" arrow>
                  <a
                    style={{ cursor: "pointer" }}
                    href={externalLink}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <em className="icon ni ni-external text-grey" style={iconStyle}></em>
                  </a>
                </Tooltip>
              );

              return (
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "8px",
                    flexWrap: "nowrap",
                    justifyContent: "flex-start",
                  }}
                >
                  {isAgentLink ? (
                    externalLink ? linkOnlyAction : fillFormAction
                  ) : isMultiple ? (
                    <>
                      <Tooltip title="View" placement="top" arrow>
                        <a
                          style={{ cursor: "pointer" }}
                          onClick={() =>
                            this.addMenuHistory("/agent_form_submissions/" + formLink)
                          }
                        >
                          <em className="icon ni ni-card-view text-info" style={iconStyle}></em>
                        </a>
                      </Tooltip>
                      {divider}
                      {fillFormAction}
                    </>
                  ) : isRejected ? (
                    <>
                      <Tooltip title="Resubmit Form" placement="top" arrow>
                        <a
                          style={{ cursor: "pointer" }}
                          onClick={() => this.addMenuHistory("/agent_form_submit/" + formLink)}
                        >
                          <em className="icon ni ni-edit text-primary" style={iconStyle}></em>
                        </a>
                      </Tooltip>
                      {divider}
                      <Tooltip title="View" placement="top" arrow>
                        <a
                          style={{ cursor: "pointer" }}
                          onClick={() =>
                            this.addMenuHistory("/agent_single_submissions/" + formToken)
                          }
                        >
                          <em className="icon ni ni-eye text-info" style={iconStyle}></em>
                        </a>
                      </Tooltip>
                      {divider}
                      <Tooltip title="Download" placement="top" arrow>
                        <a
                          style={{ cursor: "pointer" }}
                          onClick={() => this.downloadSubmissionPdf(formLink)}
                        >
                          <em className="icon ni ni-download text-primary" style={iconStyle}></em>
                        </a>
                      </Tooltip>
                      {divider}
                      <Tooltip title="Rejected" placement="top" arrow>
                        <span style={{ cursor: "default", lineHeight: 1 }}>
                          <em className="icon ni ni-cross-circle text-danger" style={iconStyle}></em>
                        </span>
                      </Tooltip>
                    </>
                  ) : isPending ? (
                    <>
                      <Tooltip title="View" placement="top" arrow>
                        <a
                          style={{ cursor: "pointer" }}
                          onClick={() =>
                            this.addMenuHistory("/agent_single_submissions/" + formToken)
                          }
                        >
                          <em className="icon ni ni-eye text-info" style={iconStyle}></em>
                        </a>
                      </Tooltip>
                      {divider}
                      <Tooltip title="Download" placement="top" arrow>
                        <a
                          style={{ cursor: "pointer" }}
                          onClick={() => this.downloadSubmissionPdf(formLink)}
                        >
                          <em className="icon ni ni-download text-primary" style={iconStyle}></em>
                        </a>
                      </Tooltip>
                      {divider}
                      <Tooltip title="Pending Approval" placement="top" arrow>
                        <span style={{ cursor: "default", lineHeight: 1 }}>
                          <em className="icon ni ni-clock text-warning" style={iconStyle}></em>
                        </span>
                      </Tooltip>
                    </>
                  ) : isApproved ? (
                    <>
                      <Tooltip title="View" placement="top" arrow>
                        <a
                          style={{ cursor: "pointer" }}
                          onClick={() =>
                            this.addMenuHistory("/agent_single_submissions/" + formToken)
                          }
                        >
                          <em className="icon ni ni-eye text-info" style={iconStyle}></em>
                        </a>
                      </Tooltip>
                      {divider}
                      <Tooltip title="Download" placement="top" arrow>
                        <a
                          style={{ cursor: "pointer" }}
                          onClick={() => this.downloadSubmissionPdf(formLink)}
                        >
                          <em className="icon ni ni-download text-primary" style={iconStyle}></em>
                        </a>
                      </Tooltip>
                      {divider}
                      <Tooltip title="Approved" placement="top" arrow>
                        <span style={{ cursor: "default", lineHeight: 1 }}>
                          <em className="icon ni ni-check-circle text-success" style={iconStyle}></em>
                        </span>
                      </Tooltip>
                    </>
                  ) : (
                    fillFormAction
                  )}
                </div>
              );
            },
          },
        },
      ],
    };
  }

  async componentDidMount() {
    const servicesResponce = await listAgentForms(
      auth.getAccount(),
      auth.getToken()
    );
    // console.log("Available Client Forms: ", servicesResponce.data);

    if (
      servicesResponce.data.status === 403 ||
      servicesResponce.data.errors === "authentication missing" ||
      servicesResponce.data.errors === "jwt expired"
    ) {
      auth.logout();
    } else if (servicesResponce.data.status === 404) {
      //window.location.replace("/error");
      this.setState({
        tableLoader: false,
        tableLoaderListing: false,
      });
    } else if (servicesResponce.data.status === 200) {
      this.setState({
        tableData: servicesResponce.data.data,
        tableLoader: false,
        tableLoaderListing: false,
      });
    } else {
      this.setState({
        tableLoader: false,
        tableLoaderListing: false,
      });
      //window.location.replace("/error");
    }
  }

  format_date = (value, tableMeta) => {
    let date = value;
    if (date && date !== "") {
      //return dateFormat(date, "mmmm dS, yyyy, h:MM:ss TT");
      return dateFormat(date, "mm-dd-yyyy");
    }
    return "---";
  };

  handleSubmission = (value, tableMeta) => {
    if (value === 1) {
      //return dateFormat(date, "mmmm dS, yyyy, h:MM:ss TT");
      return (
        <span className="badge badge-outline-success">
          <em className="icon ni ni-done"></em> Yes
        </span>
      );
    } else {
      return (
        <span className="badge badge-outline-light">
          <em className="icon ni ni-caution"></em> No
        </span>
      );
    }
    return "---";
  };

  handleChange = (input) => (e) => {
    this.setState({ [input]: e.target.value });
  };

  openModal = (formData, formAccNo) => {
    const modalContent = (
      <FormRenderer
        formData={JSON.parse(formData)}
        formTitle={this.state.form_title}
        onSubmit={this.handleSubmitForm}
      // id={this.state.forms[0].id}
      // setShowResponse={(value) => this.setState({ showResponse: value })}
      />
    );
    this.setState({ modalContent: modalContent, formAccNo: formAccNo }, () => {
      window.$("#modalPreviewForm").modal("show");
    });
  };

  addMenuHistory = (link) => {
    this.props.props.history.push(link);
  };

  downloadSubmissionPdf = async (formLink) => {
    const formToken =
      formLink && formLink.includes("/") ? formLink.split("/")[1] : formLink;

    if (!formToken) {
      this.setState({ errorMessage: "Submission not found." });
      setTimeout(() => this.setState({ errorMessage: "" }), 4000);
      return;
    }

    try {
      const res = await viewAgentFormSingleSubmission(
        auth.getAccount(),
        auth.getToken(),
        formToken
      );

      if (
        res.data.status === 403 ||
        res.data.errors === "authentication missing" ||
        res.data.errors === "jwt expired"
      ) {
        auth.logout();
        return;
      }

      const pdfName =
        res.data.status === 200 &&
        res.data.data &&
        res.data.data.length > 0
          ? res.data.data[0].pdf_name
          : "";

      if (!pdfName || pdfName === "") {
        this.setState({ errorMessage: "PDF not found for this submission." });
        setTimeout(() => this.setState({ errorMessage: "" }), 4000);
        return;
      }

      this.downloadPdf(pdfName);
    } catch (error) {
      console.error("Download submission PDF error:", error);
      this.setState({
        errorMessage: "There was some error while downloading the form.",
      });
      setTimeout(() => this.setState({ errorMessage: "" }), 4000);
    }
  };

  downloadPdf = (fileName) => {
    const url = APP_LIVE_URL + "files_data/form_response_uploads/" + fileName;
    fetch(url)
      .then((x) => x.blob())
      .then((b) => {
        const objectUrl = window.URL.createObjectURL(b);
        var a = document.createElement("a");
        document.body.appendChild(a);
        a.style = "display: none";
        a.href = objectUrl;
        a.download = fileName;
        a.click();
        window.URL.revokeObjectURL(objectUrl);
        document.body.removeChild(a);
      })
      .catch((error) => {
        this.setState({
          errorMessage: "There is some error while downloading the attachment.",
        });
        setTimeout(() => this.setState({ errorMessage: "" }), 4000);
        console.error("Fetch error:", error);
      });
  };

  closeModal = () => {
    this.setState({ modalContent: null, formAccNo: "" }, () => {
      window.$("#modalPreviewForm").modal("hide");
    });
  };

  handleSubmitForm = (formData) => {
    let response = JSON.stringify(formData);
    this.saveResponse(response, this.state.formAccNo);
  };

  saveResponse = async (response, formAccNo) => {
    const submitFormReponse = await saveAgentResponse(
      auth.getAccount(),
      auth.getToken(),
      response,
      formAccNo
    );
    // console.log("saveResponse response: ", submitFormReponse.data);

    if (
      submitFormReponse.data.status === 403 ||
      submitFormReponse.data.errors === "authentication missing" ||
      submitFormReponse.data.errors === "jwt expired"
    ) {
      auth.logout();
    } else if (submitFormReponse.data.status === 404) {
      //window.location.replace("/error");
      this.setState({
        errorMessageSaveResponse:
          "There was some error while saving the response.",
      });
    } else if (submitFormReponse.data.status === 200) {
      this.setState({
        successMessageSaveResponse: "Response saved successfully.",
      });
      setTimeout(() => {
        window.location.reload();
      }, 3500);
    }
    setTimeout(() => {
      this.setState({
        errorMessageSaveResponse: "",
        successMessageSaveResponse: "",
      });
    }, 2000);
  };

  render() {
    const { step } = this.state;
    const { email, VerifyUsernameButton } = this.state;
    const values = {
      email,
      VerifyUsernameButton,
    };
    //$(".nk-block .MUIDataTable-paper-2").css("padding", "10px");
    return (
      <div className="nk-content " id="Support_Block">
        <div className="container-fluid">
          {this.props.defaultSettings === "missing" &&
            this.props.from !== "dashboard" ? (
            <SettingsError />
          ) : null}
          {/* MSA WARNING  START*/}
          {this.props.is_msa_signed === "No" &&
            this.props.from !== "dashboard" ? (
            <MsaWarning />
          ) : null}

          {/* MSA WARNING END */}

          <div className="nk-content-inner">
            <div className="nk-content-body">
              {/* PAGE TITLE START */}
              {/* RIGHTS MODAL START */}

              {/* RIGHTS MODAL End */}
              <div className="nk-block-head nk-block-head-sm">
                <div className="nk-block-between">
                  <div className="nk-block-head-content">
                    <h3 className="nk-block-title page-title">
                      <PageTitle name="Forms" icon="icon ni ni-list-check" />
                    </h3>
                  </div>
                  <div className="nk-block-head-content" id="HeadContent"></div>
                </div>
              </div>
              {/* PAGE TITLE END */}
              <div className="nk-block">
                <div className="row g-gs">
                  {/* Table 5th Col Start */}
                  <div className="col-xxl-12">
                    <div className="nk-block nk-block-lg">
                      <div className="card card-bordered">
                        <div className="card-inner">
                          {this.state.errorMessage !== "" ? (
                            <div
                              className="example-alert example-alert-revoke mt-3 mb-3"
                              style={{ marginBottom: "15px" }}
                            >
                              <div className="alert alert-pro alert-danger">
                                <div className="alert-text">
                                  <h4>Error</h4>
                                  <p>{this.state.errorMessage}</p>
                                </div>
                              </div>
                            </div>
                          ) : null}
                          {this.state.tableLoader === true ? (
                            TableLoader()
                          ) : (
                            <DataTableExtended
                              columns={this.state.columnServices}
                              tableData={this.state.tableData}
                              title=""
                            />
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                  {/* Table 5th Col End */}
                </div>
              </div>
            </div>
          </div>
          <div className="modal fade" tabIndex="-1" id="modalPreviewForm">
            <div
              className="modal-dialog modal-lg modal-dialog-top"
              role="document"
            >
              <div className="modal-content">
                <a
                  style={{ cursor: "pointer" }}
                  className="close"
                  onClick={this.closeModal}
                >
                  <em className="icon ni ni-cross"></em>
                </a>
                <div className="modal-body">
                  {this.state.errorMessageSaveResponse !== "" ? (
                    <div
                      className="example-alert "
                      style={{ marginBottom: "15px" }}
                    >
                      <div className="alert alert-pro alert-danger">
                        <div className="alert-text">
                          <h4>Error</h4>
                          <p>{this.state.errorMessageSaveResponse}</p>
                        </div>
                      </div>
                    </div>
                  ) : null}
                  {this.state.successMessageSaveResponse !== "" ? (
                    <div
                      className="example-alert "
                      style={{ marginBottom: "15px" }}
                    >
                      <div className="alert alert-pro alert-success">
                        <div className="alert-text">
                          <h4>Success</h4>
                          <p>{this.state.successMessageSaveResponse}</p>
                        </div>
                      </div>
                    </div>
                  ) : null}
                  <div className="nk-modal">{this.state.modalContent}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    defaultSettings: state.settings,
    is_msa_signed: state.is_msa_signed,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    addSettings: (payload) => dispatch(addSettings(payload)),
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(Forms);
